<template>
    <footer class="footer">
        <div class="copyright">© {{year}} Premia Partners Company Limited. All rights reserved</div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style scoped>
    .footer {
        width:100%;
        background:#eee;
        border-top: solid #ddd 1px;
        height:40px;
        display:flex;
        align-content: flex-end; 
    }
    .copyright {
        font-size:12px;
        margin:0 auto;
        line-height:40px;
        font-family: Arial, Helvetica, sans-serif;
        color:#333;
    }
    @media screen and (max-height:500px) and (min-height: 260px) {
        .footer {display:none;}
    }
</style>